//대시보드
import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import {
  Body1,
  Body2,
  Caption1,
  Sub2,
} from "../../../assets/styles/Typography";
import { Button } from "../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../Global/components/molecules/MoleculeHeader";
import { useAtom } from "jotai";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DISPLAY_LIST,
  AUTODISPLAY_CONTENT_LIST,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  SELECTED_CUSTOMER_TYPE,
  CUSTOMER_DETAIL,
  AUTODISPLAY_SELECTED_CONTENT_ID,
} from "../../AtomStates";
import OrganismDashboardDisplayList from "../components/organisms/OrganismDashboardDisplayList";
import OrganismApiDashboardContentList from "../components/organisms/OrganismApiDashboardContentList";
import PopupWrap from "../../../assets/styles/Popup";
import {
  SelectBox,
  SelectBoxTitle,
  SelectBoxList,
  SelectBoxItem,
  CustomTextarea,
  CheckBoxButton,
} from "../../../assets/styles/InputStyle";
import images from "../../../assets/styles/Images";
import {
  createDisplayOnServer,
  updateDisplayOnServer,
  getDisplayListOnServer,
  getDisplayListCustomerOnServer,
  getViewListOnServer,
  getViewApiListOnServer,
  getViewCustomListOnServer,
  getViewListCustomerOnServer,
  getViewApiListCustomerOnServer,
  getViewCustomListCustomerOnServer,
  getUserInfo,
  getUserMemberType,
  updateCustomerOnServer,
  getCustomerDetailOnServer,
  getEduTimetableLotationDetailOnServer,
  getEduBoardLotationListOnServer,
} from "../../../utils/indexedDB";
import AutodisplaySelectedPopup from "../components/molecules/AutodisplaySelectedPopup";
import AutodisplayApiSelectedPopup from "../components/molecules/AutodisplayApiSelectedPopup";
import { TabWrapType3 } from "../../../assets/styles/BusinessAnalysisStyle";
import OrganismApiContentList from "../components/organisms/OrganismApiContentList";
import TemplateApiContentsList from "../components/templates/TemplateApiContentsList";

const PageApiDashBoard = () => {
  const navigate = useNavigate();

  // 대시보드 상태 데이터
  const [stats] = useState({
    displayList: 5,
    totalContent: 20,
    activeContent: 10,
    credits: 21250,
  });
  const [activeTab, setActiveTab] = useState("content");
  // 뷰 전환 상태: 'dashboard' | 'contentsList'
  const [currentView, setCurrentView] = useState("dashboard");
  // 팝업 관련 상태
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice, setSelectedDevice] = useAtom(
    AUTODISPLAY_SELECTED_DEVICE
  );
  const [autoDisplaySelectedContentId, setAutoDisplaySelectedContentId] =
    useAtom(AUTODISPLAY_SELECTED_CONTENT_ID);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [isCustomizePopupOpen, setIsCustomizePopupOpen] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [isSelectDisplayPopupOpen, setIsSelectDisplayPopupOpen] =
    useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [addDisplayForm, setAddDisplayForm] = useState({
    deviceTitle: "",
    deviceLocation: "",
    deviceTarget: "",
    deviceSpec: {
      deviceWidth: "",
      deviceHeight: "",
      deviceWidthMM: "",
      deviceHeightMM: "",
      deviceCm: "",
      deviceResolution: "",
      deviceDPI: "",
      deviceInch: "",
    },
  });
  const [selectBoxStates, setSelectBoxStates] = useState({
    deviceDPI: false,
    deviceInch: false,
  });
  const [showDeviceSelectPopup, setShowDeviceSelectPopup] = useState(false);
  const [isTypingDPI, setIsTypingDPI] = useState(false);
  const [isTypingInch, setIsTypingInch] = useState(false);
  const [activateCount, setActivateCount] = useState(0);
  const [displayList, setDisplayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
  const [newDisplayId, setNewDisplayId] = useState(null);
  const [selectedEditDisplayId, setSelectedEditDisplayId] = useState(null);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);

  const [selectedCustomerType, setSelectedCustomerType] = useAtom(
    SELECTED_CUSTOMER_TYPE
  );
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [companyInfo, setCompanyInfo] = useState("");
  const [lotationDetail, setLotationDetail] = useState(null);

  // 고객사 정보를 불러오는 함수
  const fetchCustomerDetail = async () => {
    try {
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
      setCustomerId(customerIdFromStorage);
      if (customerIdFromStorage !== "") {
        const customerDetailResponse = await getCustomerDetailOnServer(
          customerIdFromStorage,
          isLoggedIn
        );
        if (customerDetailResponse) {
          setCustomerDetail(customerDetailResponse);
          setCompanyName(customerDetailResponse.companyName);
          setAddress(customerDetailResponse.address);
          setCompanyInfo(customerDetailResponse.companyInfo);
        }
      }
    } catch (error) {
      console.error("고객사 정보를 불러오는 중 오류가 발생했습니다:", error);
    }
  };

  const checkMemberType = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    const userMemberType = await getUserMemberType(accessToken);
    const lastUrl = sessionStorage.getItem("lastUrl");

    const currentUrl = window.location.href;
    sessionStorage.setItem("lastUrl", currentUrl);

    if (
      (lastUrl === "/DashBoard" || lastUrl === "/CreateContent") &&
      userMemberType.member_type === 99
    ) {
      navigate("/Admin");
    }

    if (userMemberType.member_type === 11) {
      navigate("/DashBoard");
    } else if (userMemberType.member_type === 12) {
      navigate("/CustomerManage");
    } else if (userMemberType.member_type === 31) {
      navigate("/EducationDashBoard");
    } else if (userMemberType.member_type === 32) {
      navigate("/EduboardManage");
    }
  };

  // 데이터 fetching 함수 분리
  const fetchContentList = async () => {
    if (!isLoggedIn) {
      return; // 로그인 상태가 아니면 API를 호출하지 않음
    }

    try {
      let response;
      const accessToken = sessionStorage.getItem("accessToken");
      const memberType = await getUserMemberType(accessToken);
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";

      if (customerIdFromStorage === "" && memberType.member_type === 21) {
        response = await getDisplayListOnServer(10, 1, isLoggedIn);
        setDisplayList(response.data);
      } else {
        response = await getDisplayListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        setDisplayList(response.data);
      }

      // 디스플레이 목록이 비어있으면 기본 더미 데이터를 서버에 저장
      // if (response.data.length === 0) {
      //   await saveDefaultDisplays();

      // }

      let viewList;
      let viewListCustom;

      if (customerIdFromStorage === "") {
        viewList = await getViewApiListOnServer(10, 1, isLoggedIn);
        viewListCustom = await getViewCustomListOnServer(10, 1, isLoggedIn);
      } else {
        viewList = await getViewApiListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        viewListCustom = await getViewCustomListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
      }
      // 두 리스트 합치기
      const mergedList = [
        ...(viewList.data || []),
        ...(viewListCustom.data || []),
      ];
      // timestamp 내림차순 정렬 (최신순)
      mergedList.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      setActivateCount(viewList.activate_count + viewListCustom.activate_count);
      setContentList(mergedList);
    } catch (error) {
      console.error("콘텐츠 리스트를 불러오는 중 오류가 발생했습니다:", error);
    }
  };

  const fetchCompanyName = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    const userInfo = await getUserInfo(accessToken);
    if (customerId === "") {
      setCustomerName(userInfo.organization_name);
    }
  };

  const getLotationList = async () => {
    try {
      const customerId = sessionStorage.getItem("customerId");

      // 편성 데이터 로드
      const lotationDetailData = await getEduTimetableLotationDetailOnServer(
        customerId
      );
      setLotationDetail(lotationDetailData);
    } catch (error) {
      console.error("Error fetching lotation list:", error);
    } finally {
      // setIsTimetableLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        await checkMemberType();
        await getLotationList();
        await fetchContentList();
        await fetchCustomerDetail();
        await fetchCompanyName();
      } catch (error) {
        console.error("Error initializing:", error);
      } finally {
        // setIsTimetableLoading(false);
      }
    };
    init();
  }, []);

  // 팝업 핸들러들
  const showPopup = () => {
    setIsCustomizePopupOpen(true);
  };

  const handleCustomizePopupClose = () => {
    setIsCustomizePopupOpen(false);
    setActiveTabIndex(0);
    setAddDisplayForm({
      deviceTitle: "",
      deviceLocation: "",
      deviceTarget: "",
      deviceSpec: {
        deviceWidth: "",
        deviceHeight: "",
        deviceCm: "",
        deviceResolution: "",
        deviceDPI: "",
        deviceInch: "",
      },
    });
  };

  // AutodisplaySelectedPopup에서 기기 선택 시
  const handleAutoDisplaySelect = (selectedDisplayId) => {
    const originalDevice = displayList.find((d) => d._id === selectedDisplayId);
    // console.log("originalDevice", originalDevice);
    if (originalDevice) {
      // setSelectedDevice(originalDevice);
      setShowDeviceSelectPopup(false);
      // navigate("/CreateContent", { state: { selectedDevice: originalDevice } });
    }
  };

  const handleAutoDisplayClose = () => {
    setShowDeviceSelectPopup(false);
    setSelectedEditDisplayId(null);
  };

  const handleSaveNewDisplay = async (displayData) => {
    try {
      // customerId가 있으면 displayData에 추가
      if (customerId !== "") {
        displayData.customer = customerId;
      }
      // 1. 먼저 새 디스플레이 ID를 생성
      const newDisplayId = await createDisplayOnServer(isLoggedIn);

      if (!newDisplayId) {
        throw new Error("디스플레이 ID 생성에 실패했습니다.");
      }

      // 2. 생성된 ID에 디스플레이 정보를 업데이트
      await updateDisplayOnServer(newDisplayId, displayData);

      // 3. 디스플레이 목록 새로고침
      await fetchContentList();
    } catch (error) {
      console.error("새 디스플레이 저장 실패:", error);
      throw error; // AutodisplaySelectedPopup에서 에러 처리하도록 전달
    }
  };

  // 사이즈 계산 로직
  useEffect(() => {
    const { deviceDPI, deviceInch } = addDisplayForm.deviceSpec;

    if (!deviceDPI || !deviceInch) return;

    try {
      const resolutionMatch = deviceDPI.match(/(\d{3,})\s*[×x*]\s*(\d{3,})/);
      const inchMatch = deviceInch.match(/(\d+(\.\d+)?)/);

      if (!resolutionMatch || !inchMatch) return;

      const widthPx = parseInt(resolutionMatch[1], 10);
      const heightPx = parseInt(resolutionMatch[2], 10);
      const diagonalInch = parseFloat(inchMatch[1]);

      const aspectRatio = widthPx / heightPx;
      const heightInch = diagonalInch / Math.sqrt(aspectRatio ** 2 + 1);
      const widthInch = heightInch * aspectRatio;

      const widthMm = Math.round(widthInch * 25.4);
      const heightMm = Math.round(heightInch * 25.4);

      setAddDisplayForm((prev) => ({
        ...prev,
        deviceSpec: {
          ...prev.deviceSpec,
          deviceWidth: widthPx.toString(),
          deviceHeight: heightPx.toString(),
          deviceWidthMM: widthMm.toString(),
          deviceHeightMM: heightMm.toString(),
        },
      }));
    } catch (e) {
      console.error("Failed to calculate display size", e);
    }
  }, [
    addDisplayForm.deviceSpec.deviceDPI,
    addDisplayForm.deviceSpec.deviceInch,
  ]);

  // 새 콘텐츠 클릭 시 리스트 뷰로 이동
  const handleNewContentClick = () => {
    setCurrentView("contentsList");
  };

  // 리스트 뷰에서 대시보드로 복귀
  const handleBackToDashboard = () => {
    setCurrentView("dashboard");
    setShowDeviceSelectPopup(false);
    setSelectedEditDisplayId(null);
  };

  if (currentView === "contentsList") {
    return (
      <TemplateApiContentsList
        onBack={handleBackToDashboard}
        onCreateContent={() => {
          // 기존 동작 유지: API 콘텐츠 생성 페이지 이동 및 선택 콘텐츠 ID 리셋
          navigate("/CreateApiContent");
          setAutoDisplaySelectedContentId("");
        }}
      />
    );
  }

  const handleCustomerSubmit = async () => {
    try {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);

      let customerType;
      if (userMemberType.member_type === 22) {
        customerType = 2;
      } else if (userMemberType.member_type === 12) {
        customerType = 1;
      } else if (userMemberType.member_type === 99) {
        customerType = selectedCustomerType;
      }
      const data = {
        companyName: companyName,
        address: address,
        companyInfo: companyInfo,
        customerType: customerType,
      };

      await updateCustomerOnServer(customerId, data);

      setCustomerDetail(data);

      // // 저장 후 리스트 다시 불러오기
      // const customerListResponse = await getCustomerListOnServer(
      //   customerType,
      //   10,
      //   1,
      //   isLoggedIn
      // );

      // if (customerListResponse) {
      //   setCustomerList(customerListResponse.data);
      // }
    } catch (error) {
      console.error("고객사 등록에 실패했습니다:", error);
    } finally {
      setShowCustomerPopup(false);
    }
  };

  return (
    <>
      <DashboardContainer>
        <MoleculeHeader />

        {/* 메인 컨텐츠 */}
        <MainContent>
          {/* 상단 섹션 */}
          <TopSection>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <CompanyInfo>
                {/* <Avatar /> */}
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  {/* <CompanyName>{customerName}</CompanyName> */}
                  <CompanyName>
                    {customerDetail?.companyName || customerName}
                  </CompanyName>
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      background: "#f7f8fa",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      color: "#666",
                      fontSize: "14px",
                      fontWeight: "500",
                      fontFamily: "Pretendard",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowCustomerPopup(true);
                      setCompanyName(customerDetail?.companyName || "");
                      setAddress(customerDetail?.address || "");
                      setCompanyInfo(customerDetail?.companyInfo || "");
                    }}
                  >
                    <EditIcon />
                    고객사 정보
                  </button>
                </div>
              </CompanyInfo>
              <Body2 color="gray600" style={{ textAlign: "left" }}>
                {customerDetail?.address}
              </Body2>
            </div>
            <ButtonGroup>
              {/* <StyledPrimaryLightestButton onClick={() => setShowDeviceSelectPopup(true)}>
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0 }}
                >
                  <circle cx="10.11" cy="10.11" r="7.11" stroke="#256EF4" strokeWidth="1.5" />
                  <line x1="9.89549" y1="6.4099" x2="9.89549" y2="10.1839" stroke="#256EF4" strokeWidth="1.86911" strokeLinecap="round" />
                  <line x1="11.8236" y1="11.5456" x2="9.92994" y2="10.1967" stroke="#256EF4" strokeWidth="1.86911" strokeLinecap="round" />
                </svg>
                <Sub2 color="primary">새 디스플레이</Sub2>
              </StyledPrimaryLightestButton> */}

              <Button
                Large
                Primary
                Fill
                onClick={handleNewContentClick}
                style={{ display: "inline-flex", alignItems: "center" }}
              >
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0 }}
                >
                  <path
                    d="M9.99935 4.16669V15.8334M4.16602 10H15.8327"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <Sub2 color="white">콘텐츠 생성하기</Sub2>
              </Button>
            </ButtonGroup>
          </TopSection>

          {/* 통계 섹션 */}
          <StatsSection>
            {/* <SectionTitle>콘텐츠 활성화 현황</SectionTitle> */}
            <StatsGrid>
              <StatCard>
                <StatHeader>
                  <Body2 color="gray600"> 콘텐츠 편성 </Body2>
                  {/* <Body2 color="gray600">개수</Body2> */}
                </StatHeader>
                <StatValue>
                  {lotationDetail?.lotationContents?.length || 0}
                  <span style={{ fontSize: "0.5em" }}>(활성)</span> /{" "}
                  {contentList.length}
                  <span style={{ fontSize: "0.5em" }}>(전체)</span>
                </StatValue>
              </StatCard>
              {/* <StatCard>
                <StatHeader>
                  <Body2 color="gray600">활성화 콘텐츠 </Body2>
                </StatHeader>
                <StatValue>{activateCount || "0"} 건</StatValue>
              </StatCard> */}
              {/* <StatCard>
                <StatHeader>
                  <Body2 color="gray600">등록 디스플레이 </Body2>
                </StatHeader>
                <StatValue>{displayList.length} 건</StatValue>
              </StatCard> */}
              {/* <StatCard>
                <StatHeader>
                  <Body2 color="gray600">멤버십 </Body2>
                </StatHeader>
                <StatValue>Custom</StatValue>
              </StatCard> */}
              {/* <StatCard>
              <StatHeader>
                <Body2 color="gray600">등록된 디스플레이 수 (갯수) </Body2>
        
              </StatHeader>
              <StatCardContent>
                <StatValue>{displayList.length} 개</StatValue>

                <AddDisplayButton
                  onClick={() => setShowDeviceSelectPopup(true)}
                >
                  + 사이즈 등록
                </AddDisplayButton>
              </StatCardContent>
            
            </StatCard> */}
            </StatsGrid>
          </StatsSection>
          {/* 탭 및 테이블 섹션 */}

          <TableSection>
            <OrganismApiContentList
              contentList={contentList}
              lotationDetail={lotationDetail}
              onLotationUpdate={async () => {
                // 편성 데이터가 업데이트되면 다시 로드
                try {
                  const updatedLotationDetail =
                    await getEduTimetableLotationDetailOnServer(customerId);
                  setLotationDetail(updatedLotationDetail);
                } catch (error) {
                  console.error("Error refreshing lotation detail:", error);
                }
              }}
            />
          </TableSection>
        </MainContent>

        {/* 기기 없음 알림 팝업 */}

        {/* 기기 선택 팝업 */}
        {showDeviceSelectPopup && (
          <AutodisplayApiSelectedPopup
            onClose={handleAutoDisplayClose}
            onSelect={handleAutoDisplaySelect}
            onSaveNewDisplay={handleSaveNewDisplay}
            selectedEditDisplayId={selectedEditDisplayId}
            // handleRigistDisplay={handleRegisterDisplay}
          />
        )}
      </DashboardContainer>
      {showCustomerPopup && (
        <PopupWrap
          TitleFlex
          title="고객사 정보"
          buttonType="Fill"
          confirmText={"편집 내용 저장"}
          isModal={true}
          onCancel={() => setShowCustomerPopup(false)}
          onConfirm={handleCustomerSubmit}
          showTabs={true}
          eventState={false}
          creditRequestCustomPersona={100}
          isFormValid={
            !!companyName &&
            !!address &&
            (companyName !== customerDetail?.companyName ||
              address !== customerDetail?.address ||
              companyInfo !== customerDetail?.companyInfo)
          }
          body={
            <div>
              <>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    고객사 명 {/* <span style={{ color: "red" }}>*</span> */}
                  </Body2>
                  <PopupContent>
                    <InputBox>
                      <InputText
                        placeholder="입력해주세요."
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                    </InputBox>
                  </PopupContent>
                </div>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    주소지 {/* <span style={{ color: "red" }}>*</span> */}
                  </Body2>
                  <PopupContent>
                    <InputBox>
                      <InputText
                        placeholder="입력해주세요."
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </InputBox>
                  </PopupContent>
                </div>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    고객사 관련 정보{" "}
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </Body2>
                  <PopupContent>
                    <InputBox2>
                      <InputTextArea
                        value={companyInfo}
                        onChange={(e) => setCompanyInfo(e.target.value)}
                        placeholder="입력해주세요."
                        rows={4}
                      />
                    </InputBox2>
                  </PopupContent>
                </div>
              </>
            </div>
          }
        />
      )}
    </>
  );
};

export default PageApiDashBoard;

// PopupContent 스타일 추가
export const PopupContent = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

// 스타일 컴포넌트들
const DashboardContainer = styled.div`
  width: 100%;
  max-width: 2330px;
  margin: 0 auto;
  background: ${palette.white};
  min-height: 100vh;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 40px;
  height: 56px;
`;

const Logo = styled.h1`
  font-family: Poppins;
  font-weight: 700;
  font-size: 20px;
  color: #323232;
  margin: 0;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const CreditSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CreditIcon = styled.div`
  width: 20px;
  height: 20px;
  background: #ffd54a;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const CreditText = styled.span`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  color: #323232;
`;

const CreditArrow = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cccccc;
`;

const NotificationIcon = styled.div`
  width: 18px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MoreIcon = styled.div`
  width: 18px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e0e4eb;
`;

const MainContent = styled.main`
  max-width: 1240px;
  margin: 0 auto;
  padding: 145px 0;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  background: #d9d9d9;
  border-radius: 50%;
  background-image: url("/logo192.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const CompanyName = styled.h2`
  font-family: poppins;
  font-weight: 700;
  font-size: 40px;
  color: #1e2124;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

// TemplateApiContentsList의 PrimaryLightest 스타일 버튼과 동일한 톤
const StyledPrimaryLightestButton = styled(Button).attrs({
  Large: true,
  PrimaryLightest: true,
  Fill: true,
})`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #e6f0ff !important;
  }
`;

const StatsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: -40px;
`;

const SectionTitle = styled.h3`
  font-family: Pretendard;
  font-weight: 700;

  font-size: 16px;
  color: #696969;
  margin: 0;
  text-align: left;
`;

const StatsGrid = styled.div`
  display: flex;
  gap: 20px;
`;

const StatCard = styled.div`
  flex: 1;
  background: ${palette.white};
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StatValue = styled.div`
  font-family: Poppins;
  font-weight: 700;

  font-size: 30px;
  color: #666666;
  text-align: left;
`;

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

const TabGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const Tab = styled.button`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? "#E0E4EB" : "#e0e4eb")};
  background: ${({ active }) => (active ? "#F7F8FA" : "transparent")};
  color: ${palette.gray700};
  font-weight: ${({ active }) => (active ? 600 : 400)};
  font-size: 15px;
  cursor: pointer;
  margin-right: 8px;
  transition: background 0.2s, color 0.2s, border 0.2s;

  &:last-child {
    margin-right: 0;
  }
`;

const Table = styled.div`
  border-radius: 0;
  overflow: hidden;
`;

const TableHeader = styled.div`
  display: flex;
  background: #eef2f7;
`;

const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const TableRow = styled.div`
  display: flex;
  background: ${palette.white};

  &:not(:last-child) {
    border-bottom: 1px solid #cdd1d5;
  }
`;

const HeaderCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  color: #131416;
  border-right: 1px solid #d6e0eb;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const TableCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 17px;
  color: #464c53;
  border-right: 1px solid #cdd1d5;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const PopupFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0;
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 4px;
  flex: ${(props) => props.flex || "none"};
  margin-bottom: -10px;

  Body2 {
    margin-bottom: 10px;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputGroup = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SizeInput = styled.input`
  flex: 1;
  padding: 16px;
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  font-size: 1rem;
  color: ${palette.gray700};

  &:focus {
    outline: none;
    border-color: ${palette.primary};
  }

  &::placeholder {
    color: ${palette.gray500};
  }
`;

const SizeUnit = styled.span`
  font-size: 14px;
  color: ${palette.gray600};
  min-width: 24px;
`;

const ButtonCenter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const InfoBox = styled.div`
  background-color: ${palette.primaryLightest};
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 16px;
`;

const LargeButton = styled(Button)`
  width: 200px;
  padding: 16px 32px;
  font-size: 16px;
  min-height: 56px;
`;

const DirectInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

const ResetButton = styled.button`
  background: none;
  border: none;
  color: ${palette.gray400};
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background-color: ${palette.gray100};
    color: ${palette.gray700};
  }
`;

const ContentLink = styled.a`
  color: ${palette.primary};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${palette.primary}DD;
    text-decoration: underline;
  }

  &:visited {
    color: ${palette.primary};
  }
`;

const CustomPopupSubtitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${palette.gray600};
  margin: 0;
  margin-bottom: 12px;
`;

const AddDisplayButton = styled.button`
  height: 32px;
  padding: 0 12px;
  background: transparent;
  border: 1px solid #e0e4eb;
  border-radius: 6px;
  color: #8a949e;
  font-size: 14px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 21px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  &:hover {
    background: #f9fafb;
    border-color: #cdd1d5;
  }
`;

const StatCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9124 4.12883C22.329 3.71227 23.0044 3.71227 23.4209 4.12883L28.7542 9.46216C28.9543 9.6622 29.0667 9.93351 29.0667 10.2164C29.0667 10.4993 28.9543 10.7706 28.7542 10.9707L16.7542 22.9707C16.5542 23.1707 16.2829 23.2831 16 23.2831H10.6667C10.0776 23.2831 9.6 22.8055 9.6 22.2164V16.8831C9.6 16.6002 9.71238 16.3289 9.91242 16.1288L21.9124 4.12883ZM22.6667 6.39157L20.1752 8.88307L24 12.7079L26.4915 10.2164L22.6667 6.39157ZM22.4915 14.2164L18.6667 10.3916L11.7333 17.3249V21.1497H15.5582L22.4915 14.2164ZM6.4 7.01641C6.25272 7.01641 6.13333 7.1358 6.13333 7.28307V26.4831C6.13333 26.6303 6.25272 26.7497 6.4 26.7497H25.6C25.7473 26.7497 25.8667 26.6303 25.8667 26.4831V17.1497C25.8667 16.5606 26.3442 16.0831 26.9333 16.0831C27.5224 16.0831 28 16.5606 28 17.1497V26.4831C28 27.8086 26.9255 28.8831 25.6 28.8831H6.4C5.07452 28.8831 4 27.8086 4 26.4831V7.28307C4 5.95759 5.07452 4.88307 6.4 4.88307H15.7323C16.3214 4.88307 16.799 5.36064 16.799 5.94974C16.799 6.53884 16.3214 7.01641 15.7323 7.01641H6.4Z"
      fill="#8A949E"
    />
  </svg>
);

const InputBox = styled.div`
  height: 56px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const InputBox2 = styled.div`
  height: 150px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

const InputText = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  &::placeholder {
    color: ${palette.gray300};
  }
`;

const InputTextArea = styled.textarea`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  padding-top: 16px;
  resize: vertical;
  &::placeholder {
    color: ${palette.gray300};
  }
`;
